import { render, staticRenderFns } from "./loan.html?vue&type=template&id=d5f5b526&"
import script from "./loan.js?vue&type=script&lang=js&"
export * from "./loan.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5f5b526')) {
      api.createRecord('d5f5b526', component.options)
    } else {
      api.reload('d5f5b526', component.options)
    }
    module.hot.accept("./loan.html?vue&type=template&id=d5f5b526&", function () {
      api.rerender('d5f5b526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/easycash-indo/webview/help-center/loan/loan.vue"
export default component.exports